
import React from 'react';
import TextFields from '@material-ui/icons/TextFields';
import PlusOne from '@material-ui/icons/PlusOne';
import DateRange from '@material-ui/icons/DateRange';
import Schedule from '@material-ui/icons/Schedule';
import Group from '@material-ui/icons/Group';
import Phone from '@material-ui/icons/Phone';
import Email from '@material-ui/icons/Email';
import ToggleOn from '@material-ui/icons/ToggleOn';
import LocationOn from '@material-ui/icons/LocationOn';
import {
  phoneType,
  emailType,
  yesNoType,
} from '@pingum/api-services/EventDataService/EventDataTypes';

export const getIconForEventData = (eventData, iconClass) => {
  switch (eventData.type) {
    case 'Text':
      return <TextFields color="primary" className={iconClass} />;
    case 'Number':
      return <PlusOne color="primary" className={iconClass} />;
    case 'Date':
      return <DateRange color="primary" className={iconClass} />;
    case 'Datetime':
      return <Schedule color="primary" className={iconClass} />;
    case 'User':
      return <Group color="primary" className={iconClass} />;
    case 'Address':
      return <LocationOn color="primary" className={iconClass} />;
    case 'Phone':
      return <Phone color="primary" className={iconClass} />;
    case 'Email':
      return <Email color="primary" className={iconClass} />;
    case 'YesNo':
      return <ToggleOn color="primary" className={iconClass} />;
    default:
      return <TextFields color="primary" className={iconClass} />;
  }
};

const validateEmail = (email) => {
  // eslint-disable-next-line max-len
  const regexp = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  return regexp.test(email);
};

const validatePhone = (phone) => {
  // eslint-disable-next-line max-len
  const regexp = new RegExp(/^[\s()+-]*([0-9][\s()+-]*){6,20}$/);
  return regexp.test(phone);
};

export const getEventDataValidationText = (eventData, required) => {
  let isValid = null;

  if (required && (!eventData.value || eventData.value.length === 0)) {
    isValid = 'Required';
  } else if (eventData.type === phoneType && !!eventData.value && eventData.value.length > 0 && !validatePhone(eventData.value)) {
    isValid = 'Please provide a valid phone number';
  } else if (eventData.type === emailType && !!eventData.value && eventData.value.length > 0 && !validateEmail(eventData.value)) {
    isValid = 'Please provide a valid email';
  } else if (eventData.type === yesNoType) {
    if ((eventData.configuration.moreInfoOnYes && eventData.value && eventData.value.startsWith('Yes') && eventData.value.length <= 5)
    || (eventData.configuration.moreInfoOnNo && eventData.value && eventData.value.startsWith('No') && eventData.value.length <= 4)) {
      isValid = 'Please provide more information on your answer';
    }
  }

  return isValid;
};

export const getYesNoRadioGroupValue = (yesNoValue = '') => {
  if (yesNoValue.startsWith('Yes') || yesNoValue.startsWith('Yes,')) {
    return 'Yes';
  }
  if (yesNoValue.startsWith('No') || yesNoValue.startsWith('No,')) {
    return 'No';
  }
  return yesNoValue;
};

export const showYesNoMoreInfoField = (yesNoValue = '', configuration = {}) => {
  if (yesNoValue.startsWith('Yes') && configuration.moreInfoOnYes) {
    return true;
  }
  if (yesNoValue.startsWith('No') && configuration.moreInfoOnNo) {
    return true;
  }
  return false;
};

export const getYesNoMoreInfoValue = (yesNoValue) => {
  if (yesNoValue.startsWith('Yes, ')) {
    return yesNoValue.substr(5);
  }
  if (yesNoValue.startsWith('No, ')) {
    return yesNoValue.substr(4);
  }
  return '';
};
